if (typeof Main !== " function") {
  let Main = function () {
    let duracion = 400;

    function fetchData() {
      let arreglo = Window.data.csv.data;
      let pais = Window.data.json.interes;
      arreglo = arreglo.map(function (d, i) {
        return {
          anio: +d.anio,
          coord: [d.lng, d.lat],
          //punto: calculaCentro([d.lng, d.lat]),
          estado: d.estado,
          municipio: d.municipio,
          semana: +d.semana,
          impacto: d.impacto,
          superficie: +d.superficie,
          id: `c-${i}`,
          fecha: getFecha(+d.anio, +d.semana),
        };
      });
      procesaData([arreglo, pais]);
      /*
      Promise.all([
        d3.csv("csv/data.csv", function (d, i) {
          return {
            anio: +d.anio,
            coord: [d.lng, d.lat],
            //punto: calculaCentro([d.lng, d.lat]),
            estado: d.estado,
            municipio: d.municipio,
            semana: +d.semana,
            impacto: d.impacto,
            superficie: +d.superficie,
            id: `c-${i}`,
            fecha: getFecha(+d.anio, +d.semana),
          };
        }),
        d3.json("json/interes.json"),
      ]).then(procesaData);
      */
    }

    //TODO: Checar bien que calcule lo que debe
    function getFecha(year, wn) {
      let dayNb = 3;
      let j10 = new Date(year, 0, 10, 12, 0, 0),
        j4 = new Date(year, 0, 4, 12, 0, 0),
        mon1 = j4.getTime() - j10.getDay() * 86400000;
      return new Date(mon1 + ((wn - 1) * 7 + dayNb) * 86400000);
    }

    function procesaData([arreglo, pais]) {
      generaGraficas(arreglo, pais);
    }

    function generaGraficas(arreglo, pais) {
      let elMapa = d3.select("#mapa") || false;
      if (elMapa) {
        let mapa = new Mapa(elMapa, duracion, arreglo, pais);
      }
      delete window.Mapa;

      let elsLinea = d3.selectAll("[data-grafica='linea']");
      elsLinea.each(function () {
        let el = d3.select(this);
        let estado = el.attr("data-estado");
        let arregloFiltrado = _.filter(arreglo, function (o) {
          return estado == o.estado.toLowerCase();
        });
        let linea = new Linea(el, duracion, arregloFiltrado);
      });
      delete window.Linea;

      let elsLineaLog = d3.selectAll("[data-grafica='linealog']");
      elsLineaLog.each(function () {
        let el = d3.select(this);
        let estado = el.attr("data-estado");
        let arregloFiltrado = _.filter(arreglo, function (o) {
          return estado == o.estado.toLowerCase();
        });
        let lineaLog = new LineaLog(el, duracion, arregloFiltrado);
      });
      delete window.LineaLog;

      let elsArea = d3.selectAll("[data-grafica='area']");
      elsArea.each(function () {
        let el = d3.select(this);
        let estado = el.attr("data-estado");
        let arregloFiltrado = _.filter(arreglo, function (o) {
          return estado == o.estado.toLowerCase();
        });
        let lineaLog = new Area(el, duracion, arregloFiltrado);
      });
      delete window.Area;

      let elsScatter = d3.selectAll("[data-grafica='scatterplot']");
      elsScatter.each(function () {
        let el = d3.select(this);
        let estado = el.attr("data-estado");
        let arregloFiltrado = _.filter(arreglo, function (o) {
          return estado == o.estado.toLowerCase();
        });
        let scatterplot = new ScatterPlot(el, duracion, arregloFiltrado);
      });
      delete window.ScatterPlot;
    }

    function setup() {
      //https://unpkg.com/d3-time-format@2.3.0/locale/es-MX.json
      d3.timeFormatDefaultLocale({
        dateTime: "%x, %X",
        date: "%d/%m/%Y",
        time: "%-I:%M:%S %p",
        periods: ["AM", "PM"],
        days: [
          "domingo",
          "lunes",
          "martes",
          "miércoles",
          "jueves",
          "viernes",
          "sábado",
        ],
        shortDays: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        months: [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre",
        ],
        shortMonths: [
          "ene",
          "feb",
          "mar",
          "abr",
          "may",
          "jun",
          "jul",
          "ago",
          "sep",
          "oct",
          "nov",
          "dic",
        ],
      });
      fetchData();
    }

    setup();

    /*
    return {
      setup: setup,
    };
    */
  };

  windowReady.ready(function () {
    let charts = new Main();
    //charts.setup();
  });
}
